import {
  FiSmartphone,
  FiServer,
  FiDatabase,
  FiPenTool,
  FiLayers,
  FiShare2,
  FiLock,
  FiUploadCloud,
  FiCheckCircle,
  FiTool,
  FiShield,
} from "react-icons/fi";

export const services = [
  {
    title: "Mobile App Development",
    tech: "React Native",
    icon: FiSmartphone,
    points: [
      "Custom apps for Android and iOS",
      "Cross-platform builds for broad market reach",
      "Integration of native device features and APIs",
    ],
  },
  {
    title: "Backend Development",
    tech: "Node.js · Express",
    icon: FiServer,
    points: [
      "Scalable server-side applications",
      "APIs that support mobile app functionality",
      "Authentication and authorization",
    ],
  },
  {
    title: "Database Development & Management",
    tech: "MongoDB · phpMyAdmin",
    icon: FiDatabase,
    points: [
      "Database design and implementation",
      "Data modelling and performance optimisation",
      "Data migration and transformation",
    ],
  },
  {
    title: "UI/UX Design",
    tech: "Figma",
    icon: FiPenTool,
    points: [
      "Interface and experience design for mobile apps",
      "Wireframes and prototypes to validate flows",
      "Design iteration based on feedback and testing",
    ],
  },
  {
    title: "Full-Stack Development",
    tech: "React Native · Node.js",
    icon: FiLayers,
    points: [
      "End-to-end delivery across frontend and backend",
      "Frontend and backend integrated as one product",
    ],
  },
  {
    title: "API Development & Integration",
    tech: "REST · Express",
    icon: FiShare2,
    points: [
      "RESTful API design and development",
      "Third-party API integration",
      "API documentation for client reference",
    ],
  },
  {
    title: "Authentication & Authorization",
    tech: "JWT · OAuth",
    icon: FiLock,
    points: [
      "Secure sign-in and session handling",
      "Role-based access to protected resources",
    ],
  },
  {
    title: "Deployment & Hosting",
    tech: "Play Store · App Store · AWS",
    icon: FiUploadCloud,
    points: [
      "Publishing apps to Google Play and the App Store",
      "Hosting and deploying backend services on AWS",
    ],
  },
  {
    title: "Testing & Quality Assurance",
    tech: "Unit · Integration",
    icon: FiCheckCircle,
    points: [
      "Unit and integration testing, frontend and backend",
      "Debugging and error resolution",
      "Performance testing",
    ],
  },
  {
    title: "Maintenance & Support",
    tech: "Ongoing",
    icon: FiTool,
    points: [
      "Updates for new OS versions and platform changes",
      "Bug fixes and issue resolution",
    ],
  },
  {
    title: "Security Audits",
    tech: "Frontend · Backend",
    icon: FiShield,
    points: [
      "Reviewing apps and APIs for vulnerabilities",
      "Applying security best practices to protect user data",
    ],
  },
];
